'use strict'

import DocTxtFileViewer from './DocTxtFileViewer.vue'

const docTxtFileViewerPlugin = {
  install: function (Vue, options) {
    const ComponentClass = Vue.extend(DocTxtFileViewer)
    const instance = new ComponentClass()
    instance.$mount() // pass nothing
    document.body.appendChild(instance.$el)
    Vue.prototype.$d_docTxtViewer = instance
  }
}
export default docTxtFileViewerPlugin
